//@flow
import React, {useState} from 'react';
import {IconButton, makeStyles, Typography} from '@material-ui/core';
import {Close} from '@material-ui/icons';
import {useForm} from 'react-hook-form';

import CustomButton from '../../../../elements/CustomButton/CustomButton';
import CustomModal from '../../../../elements/CustomModal/CustomModal';
import CustomTextField from '../../../../elements/CustomTextField/CustomTextField';
import {compressImage} from '../../../../utils/image';
import UploadImage from './UploadImage';

type SubmitData = {
  logo?: File,
  name: string,
  preview?: string,
};
export type Props = {
  open?: boolean,
  handleClose?: (success?: boolean) => void,
  onSubmit?: (data: SubmitData) => void,
};

const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    justifyItems: 'center',
    alignItems: 'center',
    gap: theme.spacing(2),
  },
  title: {
    fontWeight: 600,
    marginTop: theme.spacing(4),
  },
  closeIcon: {
    position: 'absolute',
    top: theme.spacing(1),
    right: theme.spacing(1),
  },
}));

export default function AddNewMethodModal(props: Props) {
  const {open, handleClose, onSubmit} = props;

  const {handleSubmit, register, errors} = useForm();

  const [logo, setLogo] = useState();

  const classes = useStyles();

  const handleUploadImage = async (file: File) => {
    const megabyte = 1024 * 1024;
    const originalSize = file.size / megabyte;

    if (originalSize < 1) {
      setLogo(file);
      return;
    }

    const quality = 1 / originalSize;
    try {
      const [, image] = await compressImage(undefined, file, quality);
      setLogo(image);
    } catch (error) {
      setLogo(undefined);
    }
  };

  const onHandleSubmit = data => {
    if (!onSubmit) return;
    const name = data.logoName;
    const preview = logo && URL.createObjectURL(logo);
    const payload = {logo, name, preview};

    onSubmit(payload);
  };

  return (
    <CustomModal open={open} handleCloseModal={handleClose}>
      <form className={classes.root} onSubmit={handleSubmit(onHandleSubmit)}>
        <IconButton className={classes.closeIcon} onClick={handleClose}>
          <Close />
        </IconButton>
        <Typography variant="h6" className={classes.title}>
          Añadir Otro
        </Typography>

        <CustomTextField
          label="Nombre"
          name="logoName"
          autoFocus
          error={!!errors.logoName}
          helperText={errors.logoName && errors.logoName.message}
          inputRef={register({
            required: 'Campo obligatorio',
          })}
        />
        <UploadImage
          onUpload={file => {
            handleUploadImage(file);
          }}
        />
        <CustomButton
          fullWidth
          variant="contained"
          color="primary"
          size="large"
          type="submit"
        >
          Guardar
        </CustomButton>
      </form>
    </CustomModal>
  );
}
